module.exports = __webpack_public_path__ + "img/ok-green-ico.46ea8ad7.svg";